import { CSSProperties } from 'react';

export const styles: Record<string, CSSProperties> = {
  menuItemIcon: {
    marginRight: '1rem',
  },
};
